import config from 'config';

export const getLocationPathname = () => {
  return config.app.basename
    ? window.location.pathname.replace(config.app.basename, '')
    : window.location.pathname;
};
